module.exports = "<span id=\"up-arrow\">&#9650;</span>\n<span id=\"page-text\"></span>\n<span id=\"down-arrow\">&#9660;</span>";